<template>
  <div class="page3">
    <div class="navBar">
      <img src="../assets/back.png" alt="" class="navBar_back" @click="$router.back()">
      <div class="navBar_text">更新指纹</div>
    </div>
    <div class="text_container">
      <h5>第一步:</h5>
      <p> 采集好指纹后，请用手触摸一下入户门锁按键区域唤醒门锁，按一下门锁的“0键”和 “井键”对门锁指纹进行更新，更新好后即可通过采集的指纹打开门锁。</p>
      <h5>第二步:</h5>
      <p> 操作完成后请耐心等待 1分钟 ，门锁更新好指纹后即可通过指纹开门。</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "page3"
  };
</script>

<style scoped>

</style>
